/* U Press artwork review surface — INSPECTION ONLY, v2 (high fidelity).
   =========================================================================

   WHY v1 WAS BLURRY
   v1 decoded the whole sheet into ONE bitmap capped at 1800px on its LONG edge
   and then zoomed that bitmap. Measured on 62205.4.png (7350 × 36135, 265.6 MP,
   24.5" × 120.45"):

       source                7350 x 36135
       detector working copy  428 x 2103    (0.9 MP - correct, by design)
       v1 review bitmap       366 x 1800    <- 20.1 source px per preview px
       v1 drawn at fit sheet  114 x 560 css <- 64.5 source px per css px

   Capping the LONG edge is what destroyed it: a 120" sheet collapses to 366px
   wide. Zooming in revealed nothing, because there was nothing left to reveal.

   WHAT v2 DOES INSTEAD - measured in the real browser on that same file
     A  <img> from URL.createObjectURL(file)      loaded 224ms, natural
        7350x36135, decode() 3ms, heap 36MB. The browser carries the full source
        and rasterises only what is on screen. This is the overview layer.
     B  createImageBitmap(file, sx, sy, sw, sh)   pulled a genuine 3280x3263
        full-resolution crop in 2349ms without materialising the whole sheet.
        This is the detail layer, and it is authoritative for inspection.

   ONE COORDINATE SPACE
   The <img>, the SVG overlay and the detail canvas all live inside a stage
   whose CSS size IS the source size, so 1 css px = 1 source px at scale 1. A
   single transform drives zoom and pan, which means the pink boxes cannot drift
   away from the artwork at any zoom, on any device, at any window size.

   Nothing is repaired and nothing is written back.

     upReview.open({ file, fileName, sourceW, sourceH, issues, copy,
                     onClose(why), onDecision('print'|'fix') })
       -> { close(why), state() }
*/
(function () {
  'use strict';

  /* A crop bigger than this is decoded down to it. 24 MP of RGBA is ~96 MB,
     which is safe, and still 30x the detail v1 could show. */
  var MAX_CROP_PX = 24e6;
  var CONTEXT = 0.10;          // extra margin around an area, as a fraction
  var PINK = '#ff2fb0';

  function el(html) {
    var d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstChild;
  }
  function svgEl(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
  }

  var TPL =
    '<div class="up-rv" role="dialog" aria-modal="true" aria-label="Review the areas we found in your artwork">' +
      '<div class="up-rv__panel">' +
        '<header class="up-rv__head">' +
          '<div>' +
            '<h2 class="up-rv__title" data-rv-title>Review your artwork</h2>' +
            '<p class="up-rv__mtitle" aria-hidden="true">Artwork review</p>' +
            '<p class="up-rv__sub" data-rv-sub></p>' +
            '<p class="up-rv__hcount" data-rv-hcount></p>' +
          '</div>' +
          '<button type="button" class="up-rv__x" data-rv-close aria-label="Close review">&times;</button>' +
        '</header>' +
        '<div class="up-rv__body">' +
          '<nav class="up-rv__list" data-rv-list aria-label="Areas to review"></nav>' +
          '<div class="up-rv__stagewrap">' +
            '<div class="up-rv__tools">' +
              '<div class="up-rv__nav">' +
                '<button type="button" class="up-rv__ico" data-rv-prev aria-label="Previous area">&#8249;</button>' +
                '<span class="up-rv__count" data-rv-count aria-live="polite">Area 1 of 1</span>' +
                '<span class="up-rv__count--short" data-rv-cshort aria-hidden="true"></span>' +
                '<button type="button" class="up-rv__ico" data-rv-next aria-label="Next area">&#8250;</button>' +
              '</div>' +
              '<div class="up-rv__seg" role="group" aria-label="View">' +
                '<button type="button" data-rv-fit="sheet">Fit sheet</button>' +
                '<button type="button" data-rv-fit="issue">' +
                  '<span class="up-rv__lbl--long">Fit area</span>' +
                  '<span class="up-rv__lbl--short">Fit</span></button>' +
              '</div>' +
              '<div class="up-rv__seg" role="group" aria-label="Zoom">' +
                '<button type="button" data-rv-zoom="out" aria-label="Zoom out">&minus;</button>' +
                '<button type="button" data-rv-abs="0.5">50%</button>' +
                '<button type="button" data-rv-abs="1">100%</button>' +
                '<button type="button" data-rv-abs="2">200%</button>' +
                '<button type="button" data-rv-zoom="in" aria-label="Zoom in">+</button>' +
              '</div>' +
              '<span class="up-rv__pct" data-rv-pct></span>' +
            '</div>' +
            '<div class="up-rv__viewport" data-rv-viewport>' +
              '<div class="up-rv__stage" data-rv-stage>' +
                '<img class="up-rv__sheet" data-rv-img alt="Your uploaded artwork">' +
                '<canvas class="up-rv__detail" data-rv-detail hidden></canvas>' +
                '<svg class="up-rv__svg" data-rv-svg xmlns="http://www.w3.org/2000/svg"></svg>' +
              '</div>' +
              '<div class="up-rv__loading" data-rv-loading hidden>' +
                '<span class="up-rv__spin" aria-hidden="true"></span>' +
                '<span>Loading high-resolution preview…</span>' +
              '</div>' +
            '</div>' +
            '<p class="up-rv__explain" data-rv-explain aria-live="polite"></p>' +
            '<p class="up-rv__explain up-rv__explain--short" data-rv-short></p>' +
          '</div>' +
        '</div>' +
        '<footer class="up-rv__foot">' +
          '<p class="up-rv__note">U Press has not changed your artwork. Choose what you want us to do.</p>' +
          '<div class="up-rv__acts">' +
            '<button type="button" class="up-rv__btn up-rv__btn--primary" data-rv-decide="print">Print as uploaded</button>' +
            '<button type="button" class="up-rv__btn" data-rv-decide="fix">I&rsquo;ll fix it myself</button>' +
          '</div>' +
        '</footer>' +
      '</div>' +
    '</div>';

  function open(session) {
    var root = el(TPL);
    document.body.appendChild(root);
    var prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    var lastFocus = document.activeElement;

    function $(s) { return root.querySelector(s); }
    function $$(s) { return [].slice.call(root.querySelectorAll(s)); }

    var issues = (session.issues || []).slice();
    var SW = session.sourceW || 0, SH = session.sourceH || 0;

    /* One cache per open surface, so a new file always starts empty. */
    var crops = {};
    var pending = {};

    var st = {
      idx: 0, k: 0.02, tx: 0, ty: 0,
      objectUrl: null, imgReady: false,
      closed: false, decided: null, mode: 'sheet',
      timing: {}
    };
    var t0 = (window.performance || Date).now();

    /* -------------------------------------------------------------- close */
    function close(why) {
      if (st.closed) return;
      st.closed = true;
      Object.keys(crops).forEach(function (k) {
        try { crops[k].bitmap && crops[k].bitmap.close(); } catch (e) {}
      });
      crops = {};
      if (st.objectUrl) { try { URL.revokeObjectURL(st.objectUrl); } catch (e) {} }
      document.documentElement.style.overflow = prevOverflow;
      root.remove();
      try { lastFocus && lastFocus.focus(); } catch (e) {}
      if (!st.decided && session.onClose) session.onClose(why || 'closed');
    }
    $('[data-rv-close]').addEventListener('click', function () { close('close-button'); });
    root.addEventListener('click', function (e) { if (e.target === root) close('backdrop'); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); close('escape'); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        .filter(function (n) { return !n.disabled && n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* --------------------------------------------------------- the stage
       Everything inside the stage is in SOURCE pixel units, so the overlay can
       never drift from the artwork - one transform moves them together. */
    var stage = $('[data-rv-stage]');
    var img = $('[data-rv-img]');
    var detail = $('[data-rv-detail]');
    var svg = $('[data-rv-svg]');

    stage.style.width = SW + 'px';
    stage.style.height = SH + 'px';
    img.style.width = SW + 'px';
    img.style.height = SH + 'px';
    svg.setAttribute('viewBox', '0 0 ' + SW + ' ' + SH);
    svg.setAttribute('width', SW);
    svg.setAttribute('height', SH);

    function buildOverlay() {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      issues.forEach(function (it, i) {
        var b = it.box;
        var r = svgEl('rect');
        r.setAttribute('x', b[0]); r.setAttribute('y', b[1]);
        r.setAttribute('width', b[2]); r.setAttribute('height', b[3]);
        r.setAttribute('fill', 'none');
        r.setAttribute('stroke', PINK);
        r.setAttribute('vector-effect', 'non-scaling-stroke');
        r.setAttribute('data-i', i);
        r.setAttribute('class', 'up-rv__box');
        svg.appendChild(r);

        var g = svgEl('g');
        g.setAttribute('class', 'up-rv__marker');
        g.setAttribute('data-i', i);
        var c = svgEl('circle');
        c.setAttribute('r', 15); c.setAttribute('cx', 0); c.setAttribute('cy', 0);
        c.setAttribute('fill', PINK);
        var t = svgEl('text');
        t.setAttribute('x', 0); t.setAttribute('y', 1);
        t.setAttribute('text-anchor', 'middle');
        t.setAttribute('dominant-baseline', 'middle');
        t.setAttribute('font-size', '18');
        t.setAttribute('font-weight', '700');
        t.setAttribute('fill', '#fff');
        t.textContent = String(it.n);
        g.appendChild(c); g.appendChild(t);
        svg.appendChild(g);
      });
    }

    function applyTransform() {
      stage.style.transform = 'translate(' + st.tx + 'px,' + st.ty + 'px) scale(' + st.k + ')';
      // markers keep a constant on-screen size, so they stay readable at any zoom
      var inv = 1 / st.k;
      $$('.up-rv__marker').forEach(function (g) {
        var i = +g.getAttribute('data-i');
        var b = issues[i].box;
        g.setAttribute('transform',
          'translate(' + (b[0] + 16 * inv) + ',' + (b[1] + 16 * inv) + ') scale(' + inv + ')');
        g.classList.toggle('is-on', i === st.idx);
      });
      $$('.up-rv__box').forEach(function (r) {
        var on = +r.getAttribute('data-i') === st.idx;
        r.setAttribute('stroke-width', on ? 3 : 2);
        r.setAttribute('stroke-dasharray', on ? '' : '10 7');
        r.classList.toggle('is-on', on);
      });
      $('[data-rv-pct]').textContent = Math.round(st.k * 100) + '%';
    }

    function viewport() {
      var vp = $('[data-rv-viewport]');
      return { w: vp.clientWidth || 640, h: vp.clientHeight || 420 };
    }

    function centreOn(cx, cy, k) {
      var v = viewport();
      st.k = Math.max(0.005, Math.min(4, k));
      st.tx = v.w / 2 - cx * st.k;
      st.ty = v.h / 2 - cy * st.k;
      applyTransform();
    }

    function fitSheet() {
      var v = viewport();
      st.mode = 'sheet';
      centreOn(SW / 2, SH / 2, Math.min(v.w / SW, v.h / SH) * 0.98);
    }

    function fitArea() {
      if (!issues.length) return fitSheet();
      st.mode = 'area';
      var b = issues[st.idx].box;
      var v = viewport();
      var k = Math.min(v.w / (b[2] * (1 + CONTEXT * 2)), v.h / (b[3] * (1 + CONTEXT * 2)));
      centreOn(b[0] + b[2] / 2, b[1] + b[3] / 2, k);
      loadDetail(st.idx);
    }

    /* ------------------------------------------------- the detail layer ---
       A genuine full-resolution crop of the selected area, pulled straight out
       of the customer's file. This is what makes text, thin lines, compression
       artefacts and cream backgrounds actually inspectable. */
    function cropRect(i) {
      var b = issues[i].box;
      var mx = Math.round(b[2] * CONTEXT), my = Math.round(b[3] * CONTEXT);
      var x = Math.max(0, b[0] - mx), y = Math.max(0, b[1] - my);
      var w = Math.min(SW - x, b[2] + mx * 2), h = Math.min(SH - y, b[3] + my * 2);
      return [x, y, w, h];
    }

    /* A crop taken from the <img> the browser already holds. Returns an
       ImageBitmap so both paths look the same to the caller. */
    function cropFromImg(r, opts) {
      var w = opts.resizeWidth || r[2], h = opts.resizeHeight || r[3];
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var ctx = c.getContext('2d');
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, r[0], r[1], r[2], r[3], 0, 0, w, h);
      return createImageBitmap(c);
    }

    function loadDetail(i) {
      if (crops[i]) { showDetail(i); return Promise.resolve(crops[i]); }
      if (pending[i]) return pending[i];
      var r = cropRect(i);
      var opts = {};
      var px = r[2] * r[3];
      var scale = 1;
      if (px > MAX_CROP_PX) {
        scale = Math.sqrt(MAX_CROP_PX / px);
        opts.resizeWidth = Math.max(1, Math.round(r[2] * scale));
        opts.resizeHeight = Math.max(1, Math.round(r[3] * scale));
        opts.resizeQuality = 'high';
      }
      $('[data-rv-loading]').hidden = false;
      var t = (window.performance || Date).now();
      /* Two ways to get a full-resolution crop, measured against each other on
         62205.4.png: drawing the region out of the already-decoded <img>, and
         createImageBitmap with a source rect. They came back PIXEL IDENTICAL
         (max channel difference 0) at the same cost (~2.0s each), which also
         proves the browser is not downsampling the <img>. So when the image is
         loaded we use it and decode the PNG once instead of twice; the source
         rect stays as the fallback. */
      pending[i] = (st.imgReady ? cropFromImg(r, opts) :
                    createImageBitmap(session.file, r[0], r[1], r[2], r[3], opts))
        .then(function (bmp) {
          crops[i] = { bitmap: bmp, rect: r, scale: scale, from: st.imgReady ? 'img' : 'file',
                       ms: Math.round((window.performance || Date).now() - t) };
          delete pending[i];
          if (!st.timing.firstDetail) st.timing.firstDetail = crops[i].ms;
          $('[data-rv-loading]').hidden = true;
          if (st.idx === i) showDetail(i);
          return crops[i];
        })
        .catch(function (err) {
          delete pending[i];
          $('[data-rv-loading]').hidden = true;
          try { console.warn('[up-review] crop failed', err); } catch (e) {}
        });
      return pending[i];
    }

    function showDetail(i) {
      var c = crops[i];
      if (!c) { detail.hidden = true; return; }
      var b = c.rect;
      detail.width = c.bitmap.width;
      detail.height = c.bitmap.height;
      detail.style.left = b[0] + 'px';
      detail.style.top = b[1] + 'px';
      detail.style.width = b[2] + 'px';   // always the SOURCE footprint
      detail.style.height = b[3] + 'px';
      var ctx = detail.getContext('2d');
      ctx.clearRect(0, 0, detail.width, detail.height);
      ctx.drawImage(c.bitmap, 0, 0);
      detail.hidden = false;
    }

    /* -------------------------------------------------------------- list */
    /* One area does not need a chip list AND a "1 of 1" counter AND a pair of
       arrows. The count is stamped on the panel so the small-screen rules can
       collapse that down to a single compact status. */
    function markScale() {
      var panel = root.querySelector('.up-rv__panel');
      if (!panel) return;
      panel.setAttribute('data-rv-areas', String(issues.length));
      panel.classList.toggle('is-single', issues.length <= 1);
      panel.classList.toggle('is-multi', issues.length > 1);
      var h = $('[data-rv-hcount]');
      if (h) {
        h.textContent = issues.length === 1
          ? '1 area needs review'
          : issues.length + ' areas need review';
      }
    }

    function buildList() {
      $('[data-rv-list]').innerHTML = issues.map(function (it) {
        return '<button type="button" class="up-rv__item" data-rv-go="' + (it.n - 1) + '">' +
                 '<span class="up-rv__badge">' + it.n + '</span>' +
                 '<span class="up-rv__itemtext">Area ' + it.n + '</span>' +
               '</button>';
      }).join('');
      $$('[data-rv-go]').forEach(function (b) {
        b.addEventListener('click', function () { select(+b.getAttribute('data-rv-go')); });
      });
      markScale();
    }

    /* Selecting an area always fits it - the customer should never have to zoom
       manually to see what we are asking them about. */
    function select(i) {
      st.idx = Math.max(0, Math.min(issues.length - 1, i));
      render();
      fitArea();
    }

    function render() {
      var it = issues[st.idx];
      $('[data-rv-count]').textContent = issues.length
        ? 'Area ' + (st.idx + 1) + ' of ' + issues.length : 'Whole sheet';
      var cs = $('[data-rv-cshort]');
      if (cs) cs.textContent = issues.length ? (st.idx + 1) + ' / ' + issues.length : '';
      $('[data-rv-prev]').disabled = st.idx <= 0;
      $('[data-rv-next]').disabled = st.idx >= issues.length - 1;
      $$('[data-rv-go]').forEach(function (b, i) {
        b.classList.toggle('is-on', i === st.idx);
        b.setAttribute('aria-current', i === st.idx ? 'true' : 'false');
      });
      var short = $('[data-rv-short]');
      if (short) {
        short.textContent = it && it.kind === 'whole-sheet'
          ? 'This sheet has no transparent background. The whole rectangle would print.'
          : 'This area may print as shown. Review it before continuing.';
      }
      $('[data-rv-explain]').textContent = it && it.kind === 'whole-sheet'
        ? 'This sheet has no transparent background anywhere. If that is intentional '
          + 'you can continue; if not, the whole rectangle would print.'
        : 'Area ' + (it ? it.n : 1) + ': this looks like a background behind your design. '
          + 'If it is meant to be there, choose Print as uploaded.';
      applyTransform();
    }

    $('[data-rv-prev]').addEventListener('click', function () { select(st.idx - 1); });
    $('[data-rv-next]').addEventListener('click', function () { select(st.idx + 1); });
    $$('[data-rv-fit]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('data-rv-fit') === 'sheet') fitSheet(); else fitArea();
      });
    });
    $$('[data-rv-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = viewport();
        var cx = (v.w / 2 - st.tx) / st.k, cy = (v.h / 2 - st.ty) / st.k;
        centreOn(cx, cy, st.k * (b.getAttribute('data-rv-zoom') === 'in' ? 1.6 : 1 / 1.6));
        if (st.k > 0.2) loadDetail(st.idx);
      });
    });
    $$('[data-rv-abs]').forEach(function (b) {
      b.addEventListener('click', function () {
        var target = parseFloat(b.getAttribute('data-rv-abs'));
        var it = issues[st.idx];
        if (it) centreOn(it.box[0] + it.box[2] / 2, it.box[1] + it.box[3] / 2, target);
        else centreOn(SW / 2, SH / 2, target);
        loadDetail(st.idx);
      });
    });
    $$('[data-rv-decide]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.decided = b.getAttribute('data-rv-decide');
        var cb = session.onDecision;
        close('decided');
        if (cb) cb(st.decided);
      });
    });
    svg.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-i]') : null;
      if (t) select(+t.getAttribute('data-i'));
    });

    /* pan and pinch */
    (function () {
      var vp = $('[data-rv-viewport]');
      var drag = null, pts = {}, pinch = null;
      vp.addEventListener('pointerdown', function (e) {
        pts[e.pointerId] = e;
        var ids = Object.keys(pts);
        if (ids.length === 1) {
          drag = { x: e.clientX, y: e.clientY, tx: st.tx, ty: st.ty };
          try { vp.setPointerCapture(e.pointerId); } catch (err) {}
        } else if (ids.length === 2) {
          drag = null;
          var a = pts[ids[0]], b = pts[ids[1]];
          pinch = { d: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY), k: st.k };
        }
      });
      vp.addEventListener('pointermove', function (e) {
        if (!(e.pointerId in pts)) return;
        pts[e.pointerId] = e;
        var ids = Object.keys(pts);
        if (ids.length >= 2 && pinch) {
          var a = pts[ids[0]], b = pts[ids[1]];
          var d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          var v = viewport();
          var cx = (v.w / 2 - st.tx) / st.k, cy = (v.h / 2 - st.ty) / st.k;
          centreOn(cx, cy, pinch.k * (d / Math.max(1, pinch.d)));
          return;
        }
        if (!drag) return;
        st.tx = drag.tx + (e.clientX - drag.x);
        st.ty = drag.ty + (e.clientY - drag.y);
        applyTransform();
      });
      function up(e) {
        delete pts[e.pointerId];
        if (!Object.keys(pts).length) { drag = null; pinch = null; }
      }
      vp.addEventListener('pointerup', up);
      vp.addEventListener('pointercancel', up);
      vp.addEventListener('wheel', function (e) {
        e.preventDefault();
        var r = vp.getBoundingClientRect();
        var mx = e.clientX - r.left, my = e.clientY - r.top;
        var cx = (mx - st.tx) / st.k, cy = (my - st.ty) / st.k;
        var nk = Math.max(0.005, Math.min(4, st.k * (e.deltaY < 0 ? 1.18 : 1 / 1.18)));
        st.tx = mx - cx * nk; st.ty = my - cy * nk; st.k = nk;
        applyTransform();
        clearTimeout(vp._dt);
        vp._dt = setTimeout(function () { if (st.k > 0.2) loadDetail(st.idx); }, 220);
      }, { passive: false });
    }());

    window.addEventListener('resize', function () {
      if (!st.closed) { if (st.mode === 'area') fitArea(); else fitSheet(); }
    });

    /* -------------------------------------------------------------- boot */
    buildList();
    buildOverlay();
    $('[data-rv-sub]').textContent = (session.fileName || '') +
      '  ·  ' + SW + ' × ' + SH + ' px' +
      (issues.length ? '  ·  ' + (issues.length === 1 ? '1 area needs review'
                                                      : issues.length + ' areas need review') : '');
    $('[data-rv-title]').textContent = issues.length && issues[0].kind === 'whole-sheet'
      ? 'Transparency review recommended' : 'Areas to review';
    render();
    setTimeout(function () { try { $('[data-rv-close]').focus(); } catch (e) {} }, 30);

    /* The overview is the customer's own file, carried by the browser. No
       re-encoding, no downsampled raster - what they would see opening the PNG. */
    st.objectUrl = URL.createObjectURL(session.file);
    img.addEventListener('load', function () {
      st.imgReady = true;
      st.timing.imgReady = Math.round((window.performance || Date).now() - t0);
      $('[data-rv-loading]').hidden = true;
      if (issues.length) select(0); else fitSheet();
    });
    img.addEventListener('error', function () {
      $('[data-rv-loading]').hidden = true;
      $('[data-rv-explain]').textContent =
        'We could not draw a preview of this file, but the areas we found are listed above.';
    });
    $('[data-rv-loading]').hidden = false;
    img.src = st.objectUrl;

    return {
      close: close,
      state: function () {
        return { idx: st.idx, zoom: +st.k.toFixed(3), mode: st.mode,
                 issues: issues.length, decided: st.decided, imgReady: st.imgReady,
                 sourceW: SW, sourceH: SH,
                 cached: Object.keys(crops).map(Number),
                 cropInfo: Object.keys(crops).map(function (k) {
                   var c = crops[k];
                   return { area: +k + 1, bitmap: c.bitmap.width + 'x' + c.bitmap.height,
                            rect: c.rect, scale: c.scale, from: c.from, ms: c.ms };
                 }),
                 timing: st.timing, closed: st.closed };
      }
    };
  }

  window.upReview = { version: '2.0.0', open: open };
}());
